module.exports = __webpack_public_path__ + "public/img/Optimalisasi FB Ads untuk Digital Marketing Manager.67af6e2e.png";